import { render, staticRenderFns } from "./ChooseList.vue?vue&type=template&id=2b453e83&scoped=true&"
import script from "./ChooseList.vue?vue&type=script&lang=js&"
export * from "./ChooseList.vue?vue&type=script&lang=js&"
import style0 from "./ChooseList.vue?vue&type=style&index=0&id=2b453e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b453e83",
  null
  
)

export default component.exports